import * as React from 'react'

import { Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import cn from 'classnames/bind'

import styles from './index.module.scss'

const cx = cn.bind(styles)
interface Props {
  title: string | React.ReactNode
  tooltipContent?: React.ReactNode
  compact?: boolean
}

const Title = ({ title, compact, tooltipContent }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <div
      className={cx('title', {
        compact,
      })}
    >
      <Text.Normal size="200" weight="semibold">
        {title}
      </Text.Normal>
      {!!tooltipContent && (
        <Tooltip
          attachment="bottom center"
          targetAttachment="top center"
          size="big"
          open={open}
          toggle={toggle}
          type="brand"
        >
          <div>
            <Icon.Small icon="question" encircled="grey800" />
          </div>
          {tooltipContent}
        </Tooltip>
      )}
    </div>
  )
}

export default Title
